export const socialMediaLinks = {
  instagram: "https://www.instagram.com/paylater.uz?igsh=OXAzYjY3MzUxcThz",
  telegram: "https://t.me/paylaterUz",
  facebook: "",
  twitter: "#",
  whatsapp: "",
  email: "mail@paylater.uz",
  complaintEmail: "",
};
